"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sharedHeaderContract = require("@icis/shared-header-contract");
var _SubMenuWithIframe = _interopRequireDefault(require("./SubMenuWithIframe.render"));
var _getAppConfig = require("../../constants/getAppConfig");
const SubMenuWithIframeCommodities = _ref => {
  var _getConfig$urls;
  let {
    showing,
    width,
    height,
    isMobile,
    hasHeader
  } = _ref;
  const ref = (0, _react.useRef)((_getConfig$urls = (0, _getAppConfig.getConfig)().urls) === null || _getConfig$urls === void 0 ? void 0 : _getConfig$urls.commoditiesNavUrl);
  (0, _react.useEffect)(() => {
    (0, _sharedHeaderContract.initContract)(ref.current);
    const unsubscribe = (0, _sharedHeaderContract.subscribeToUrlChanges)(_ref2 => {
      let {
        url
      } = _ref2;
      window.open(url, '_self');
    });
    return () => {
      unsubscribe();
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.default, {
    testId: "Commodities-Skeleton",
    showing: showing,
    iframeTitle: "commodities",
    url: ref.current,
    width: width,
    height: height,
    isMobile: isMobile,
    hasHeader: hasHeader,
    shouldAutoResize: true
  });
};
var _default = exports.default = SubMenuWithIframeCommodities;